import React, { useEffect, useState, useRef } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';

import moment from 'moment-timezone';

import Asterisk from 'components/Asterisk';

const NATIONALITIES = require('jsons/nationalities.json');
const JOB_POSITIONS = require('jsons/job_positions.json');
const EMPLOYER_TYPES = require('jsons/employer_types.json');
const RESPONSIBILITIES = require('jsons/responsibilities.json');

const WorkExperienceProfileBoxEdit = (props) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    setProfile({
      ...props.profile,
      responsibility: (props.profile.responsibility === '') ? [] : JSON.parse(props.profile.responsibility)
    });
  }, [props]);

  const updateProfile = (field, value) => {
    const updatedProfile = {
      ...profile,
      [field]: value
    };
    setProfile(updatedProfile);
    props.onChange(profile.id, {
      ...updatedProfile,
      responsibility: JSON.stringify(updatedProfile.responsibility)
    });
  };

  const updateResponsibility = (values) => {
    updateProfile('responsibility', values.map(value => value.id));
  };

  const deleteProfile = () => {
    props.onDelete(profile.id);
  };

  const getResponsibilityValues = (values) => {
    if (!values) return [];
    return values.map((id) => {
      return RESPONSIBILITIES.zh.filter(item => item.id === id)[0];
    });
  };

  return (profile === null ?
    <></>
  :
    <Card className="work-experience-profile-box mb-3 relative">
      <div className="grid flex user-detail-user">
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">工作職位 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <Dropdown value={JOB_POSITIONS.zh.filter(item => parseInt(item.id)===profile.job_position_id)[0]} onChange={(e) => updateProfile('job_position_id', parseInt(e.value.id))} options={JOB_POSITIONS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">工作國家 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <Dropdown value={NATIONALITIES.zh.filter(item => item.id===profile.work_nationality_id)[0]} onChange={(e) => updateProfile('work_nationality_id', e.value.id)} options={NATIONALITIES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
          </div>
        </div>
        <div className="col-12 flex flex-column gap-1">
          <label className="font-semibold">工作日期 <Asterisk /></label>
          <div className="flex flex-wrap gap-0">
            <div className="col-5 px-0 pt-0">
              <Calendar value={new Date(profile.job_start_date)} onChange={(e) => {updateProfile('job_start_date', moment(e.target.value).format('YYYY-MM-DD'))}} dateFormat="yy-mm-dd" inputClassName="w-full" />
            </div>
            <div className="col-2 flex pt-0 justify-content-center align-items-center">至</div>
            <div className="col-5 px-0 pt-0">
              <Calendar value={new Date(profile.job_end_date)} onChange={(e) => {updateProfile('job_end_date', moment(e.target.value).format('YYYY-MM-DD'))}} dateFormat="yy-mm-dd" inputClassName="w-full" />
            </div>
          </div>
        </div>
        <div className="col-12 flex flex-column gap-1">
          <label className="font-semibold">職責 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <MultiSelect value={getResponsibilityValues(profile.responsibility)} onChange={(e) => updateResponsibility(e.value)} options={RESPONSIBILITIES.zh} optionLabel="name"  placeholder="選擇" maxSelectedLabels={4} selectedItemsLabel={`已選擇 ${profile.responsibility.length} 項`} className="w-full" />
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <div className="flex align-items-center">
              <Checkbox inputId="reference_letter" name="reference_letter" onChange={(e) => {updateProfile('reference_letter', e.checked)}} checked={profile.reference_letter} />
              <label htmlFor="reference_letter" className="ml-2">推薦信</label>
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">僱主類型 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <Dropdown value={EMPLOYER_TYPES.zh.filter(item => parseInt(item.id)===profile.employer_type_id)[0]} onChange={(e) => updateProfile('employer_type_id', parseInt(e.value.id))} options={EMPLOYER_TYPES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
          </div>
        </div>
      </div>
      <Button icon="pi pi-times" onClick={deleteProfile} rounded severity="danger" style={{ top: -8, right: -8, width: 24, height: 24 }} className="absolute" />
    </Card>
  );
};

export default WorkExperienceProfileBoxEdit;